<lazy-echart
    [options]="boxPlotOptions"
    [compactLoading]="true"
></lazy-echart>
